import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsCameraHidden = React.forwardRef(
  (props: SvgIconProps, ref: any) => {
    return (
      <SvgIcon {...props} ref={ref}>
        <g fill="currentColor">
          <path
            d="M23.1131077,6.0658374L23.0088634,5.866221l-0.8383904,0.8383899v12.0457611H10.1269293l-1.0180445,1.0180473
		h13.5140533c0.2883339,0,0.5123482-0.2173615,0.5456181-0.5278759V6.2765455V6.2765441
		C23.1641197,6.1989155,23.1463757,6.1279402,23.1131077,6.0658374z"
          />
          <path
            d="M1.8738867,6.8753943H7.669426c0.221796,0,0.4147596-0.1463852,0.4879522-0.374835l0.5123501-1.896359
		h6.7470446l0.6942215-0.6986587l-0.0554485-0.106462c-0.0887184-0.1730022-0.2683725-0.2839005-0.4613361-0.2839005H8.2616224
		c-0.221796,0-0.4147596,0.1463864-0.4879522,0.3748364l-0.5145679,1.896359H1.3526652
		c-0.2816817,0-0.5212215,0.2395401-0.5212215,0.5212216v13.2767296l1.042443-1.0424423V6.8753943z"
          />
          <polygon
            points="22.8136826,2.5836344 21.8311253,1.5833334 1.6631801,21.4141464 2.6457379,22.416666 
		22.6961308,2.6989689 	"
          />
          <path
            d="M8.7983694,9.7210417c-0.851697,0.8561344-1.3196878,1.9961691-1.3196878,3.2093935v0.4569006
		l1.040225-1.040226l0.0088711-0.051013c0.2595024-1.4527664,1.4084072-2.6016712,2.8589563-2.8589554l0.051013-0.0088711
		l1.0380068-1.0380068h-0.4790802c-0.0022182,0-0.0022182,0-0.0044355,0
		C10.7856646,8.3902636,9.6500673,8.862689,8.7983694,9.7210417z"
          />
          <path
            d="M12.9925385,16.3350105L11.812582,17.514967l0.43472-0.0243969
		c1.1001091-0.059885,2.1381178-0.5256577,2.9254951-1.313036c0.7895947-0.7873764,1.2620211-1.8342552,1.3329954-2.9454546
		l0.0288334-0.4391565l-1.1622133,1.1622133l-0.0110903,0.0399227c-0.3460016,1.1156359-1.2176628,1.9872952-2.3288622,2.3288622
		l0.0000019-0.0000019L12.9925385,16.3350105z"
          />
        </g>
      </SvgIcon>
    );
  }
);

export default AppIconsCameraHidden;
